// 店铺列表
import { request } from './request'

export const getShopList = (data) => {
  const url = '/ocean/api/v1/shop/list'
  return request({
    method: 'get',
    url: url,
    params: data
  })
}
// 新店铺接口，用于新看板店铺接口 0917
export const getErpShopList = (merchantId) => {
  const url = `/ocean-bi/shop/v1/list/${merchantId}`
  return request({
    method: 'get',
    url: url,
  })
}
export const getSync = (data) => {
  const url = '/ocean/api/v1/product/shop/syn'
  return request({
    method: 'get',
    url: url,
    params: data
  })
}

export const addShop = (data) => {
  const url = '/ocean/api/v1/shop/saveOrUpdate'
  return request({
    method: 'post',
    url: url,
    data: data
  })
}
// http://192.168.101.185:8089/ocean/api/v1/shop/sysdict/list?dictCode=operate_category
export const operateCategory = (data) => {
  const url = '/ocean/api/v1/shop/sysdict/list?dictCode=operate_category'
  return request({
    method: 'get',
    url: url,
    data: data
  })
}

// 店铺详情
export const getShopDetail = (params, id) => {
  const url = `/ocean/api/v1/shop/detail/${id}`
  return request({
    method: 'get',
    url: url,
    params
  })
}

// 查看数据迁移情况
export const postsyncData = (shopId) => {
  const url = `/ocean/api/v1/shop/syn-task/log/${shopId}`
  return request({
    method: 'get',
    url: url
  })
}
// 结束任务
export const cancelTask = (data) => {
  const url = `/ocean/api/v1/shop/syn-task/${data.guid}/stop`
  return request({
    method: 'put',
    url: url
  })
}

// 查看同步情况

// 停止同步迁移

export const putStopSync = (data, id) => {
  const url = `/api/v1/shop/syn-task/${id}/stop`
  return request({
    method: 'post',
    url: url,
    data
  })
}

// 获取webhook创建失败的结果消息
export const getWebhookStatus = (data) => {
  const url = '/ocean/api/v1/shop/webhookStatus'
  return request({
    method: 'get',
    url: url,
    data
  })
}

// 重新订阅webhook
export const setWebhook = (params, shopId) => {
  const url = `/ocean/api/v1/shop/subscribe/${shopId}`
  return request({
    method: 'get',
    url: url,
    params
  })
}

// 超店BI主动绑定店铺shoplus
export const autoBind = () => {
  const url = '/ocean/api/v1/shop/sync'
  return request({
    method: 'post',
    url: url,
  })
}
